/* Barra de navegação do site que colocaremos em todas as páginas. Ela é composta por botões de acesso as páginas, home e voltar e outras funcionalidades.

*/
import React from 'react';
import { useNavigate } from 'react-router-dom';
import BotaoVoltar from "../BotaoVoltar"
import './BarraNavegacao.css';
import { 
  Home, 
  MessageSquare, 
  FileText, 
  UserPlus, 
  LogOut, 
  ChevronDown, 
  Settings
} from 'lucide-react';

import { useAuth } from '../../contextos/AuthContext'; // Importa o hook useAuth do contexto de autenticação para acessar o estado do usuário logado e funções relacionadas à autenticação

  

const BarraNavegacao = () => {
    const navigate = useNavigate(); // Hook para navegação programática
    const usuario = useAuth().dadosUsuario; // Hook para acessar o contexto de autenticação e obter os dados do usuário logado

    return (
        <nav className="navbar-container">
            <div className="navbar-conteudo">
                {/* Lado Esquerdo: Home e Componente BotaoVoltar desacoplado */}
                <div className="grupo-nav">
                    <button 
                        className="btn-menu-nav"
                        onClick={() => navigate('/')}
                    >
                        <Home size={16} className="icone-nav-btn" />
                        <span>Home</span>
                    </button>

                    <span className="text-gray-300">|</span>
                    
                    <BotaoVoltar />

                </div>
            

            {/* Lado Direito: Demais menus */}

                <div className="grupo-nav">

                    {!usuario && (
                        // Se o usuário não estiver logado, mostramos os itens de cadastro e login
                        <>
                        <button 
                            className="btn-menu-nav"
                            onClick={() => navigate('/cadastro-usuario')}>
                            <UserPlus size={16} className="icone-nav-btn" />
                            <span>Cadastro</span>                                 

                        </button>

                    
                        </>
                        )
                    }   


                    <button 
                        className="btn-menu-nav"
                        onClick={() => navigate('/listagem-forum')}
                    >
                        <MessageSquare size={16} className="icone-nav-btn" />
                        <span>Fórum</span>
                    </button>

                    <span className="divisor-vertical">|</span>

                    <button 
                        className="btn-menu-nav"
                        onClick={() => navigate('/listagem-artigos')}
                    >
                        <FileText size={16} className="icone-nav-btn" />
                        <span>Artigos</span>
                    </button>

                    <span className="divisor-vertical">|</span>

                    {usuario && (
                        // Se o usuário estiver logado, mostramos o botão para o painel de controle e o botão de logout
                        <>
                        <button 
                            className="btn-menu-nav"
                            onClick={() => navigate('/painel-controle')}>
                            <Settings size={16} className="icone-nav-btn" />
                            <span>Painel de Controle</span>                                 

                        </button>

                    
                        </>
                        )
                    }   


                </div>
            </div>
        </nav>
    )

}

export default BarraNavegacao;